<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="Plan">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 任务计划管理
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="toAddNew">新增</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="计划名称">
                <el-input placeholder="请输入计划名称" v-model="seefrom.name"></el-input>
              </el-form-item>
              <el-form-item label="管理层级">
                <el-select placeholder="请选择" v-model="seefrom.ma_id">
                  <el-option
                    v-for="item in Hierarchy"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="operation/programtab/findAll"
            :parent="self"
            :config="config"
            :other="other"
            ref="plan"
          >
            <template slot="last">
              <el-table-column label="任务生成时间">
                <template slot-scope="scope">
                  <span v-if="scope.row.period === 0">每日</span>
                  <span v-if="scope.row.period === 1">每周第{{scope.row.open_time}}天</span>
                  <span v-if="scope.row.period === 2">每月第{{scope.row.open_time}}天</span>
                  <span v-if="scope.row.period === 3">每年第{{scope.row.month}}月第{{scope.row.open_time}}天</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="300" align="center">
                <template slot-scope="scope">
                  <el-link
                    :icon="scope.row.status === 0 ? 'iconfont iconcheck1' : 'iconfont icontingyong'"
                    type="text"
                    size="small"
                    @click="fConnect(scope)"
                  >{{scope.row.status === 0 ?'启用':'停用'}}</el-link>
                  <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    :disabled="scope.row.status === 1"
                    @click="toEdit(scope.$index, scope.row, true)"
                  >编辑</el-link>
                  <!-- <el-link icon="iconfont iconadd" type="text" size="small">添加</el-link> -->
                  <el-link
                    icon="iconfont icondelete"
                    type="text"
                    size="small"
                    :disabled="scope.row.status === 1"
                    @click="deletePlan(scope.$index, scope.row)"
                  >删除</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <!-- dialog -->
        <el-dialog
          class="editDialog"
          :visible.sync="displayForm"
          :title="title"
          :close-on-click-modal="false"
        >
          <el-form ref="addEquipment" :model="addEquipment" v-show="!loadingStatus" :rules="rules">
            <el-form-item label="计划名称" prop="name">
              <el-input placeholder="请输入计划名称" v-model.trim="addEquipment.name"></el-input>
            </el-form-item>
            <el-form-item label="任务内容" prop="content">
              <el-input style="font-family:Microsoft YaHei" type="textarea" placeholder="请输入任务名称" v-model="addEquipment.content"></el-input>
            </el-form-item>
            <el-form-item label="管理层级" prop="ma_id">
              <el-select placeholder="请选择" v-model="addEquipment.ma_id" :popper-append-to-body="false">
                <el-option
                  v-for="item in Hierarchy"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="任务周期" prop="period">
              <el-select placeholder="请选择" v-model="addEquipment.period" @change="ifCreateTime" :popper-append-to-body="false">
                <el-option
                  v-for="item in Cycle"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="任务生成月份" prop="month" v-if="showMounths">
              <el-select placeholder="请选择" v-model="addEquipment.month" :popper-append-to-body="false">
                <el-option v-for="item in 12" :key="'item'+item" :value="item" :label="item+'月'"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="任务生成时间" prop="open_time" v-if="showDays">
              <el-select placeholder="请选择" v-model="addEquipment.open_time" v-if="selectDays" @change="currWeekChange" :popper-append-to-body="false">
                <el-option
                  v-for="(item, index) in ['周一','周二','周三','周四','周五','周六','周日',]"
                  :key="'item'+index"
                  :value="index+1"
                  :label="item"
                ></el-option>
              </el-select>
              <el-select
                placeholder="请选择"
                v-model="addEquipment.open_time"
                v-if="selectMounth"
                @change="currMounthChange"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in 31"
                  :key="'item'+item"
                  :value="item"
                  :label="'每月第'+item+'天'"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="displayForm = false">取 消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitForm">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入计划名称", trigger: "blur" }],
        content: [
          { required: true, message: "请输入任务内容", trigger: "blur" },
          { max: 150, message: "任务内容不可多于150字", trigger: "blur" }
        ],
        ma_id: [{ required: true, message: "请选择管理层级", trigger: "change" }],
        period: [{ required: true, message: "请选择任务周期", trigger: "blur" }]
      },
      tabName: "Plan",
      loading: true,
      form_jsgl: {},
      displayForm: false,
      showTable: true,
      other: {},
      items: [],
      loadingStatus: false,
      //弹框标题
      title: "",
      status: "",
      seefrom: {
        name: "",
        hierarchy: ""
      },
      addEquipment: {
        name: "",
        content: "",
        ma_id: "",
        period: "",
        month: "",
        open_time: "",
        status: ""
      },
      edit_id: "",
      //任务生成时间
      showDays: false,
      showMounths: false,
      selectDays: false,
      selectMounth: false,
      //下拉框
      Hierarchy: [],
      Cycle: [
        { label: "每日", id: 0 },
        { label: "每周", id: 1 },
        { label: "每月", id: 2 },
        { label: "每年", id: 3 }
      ]
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "name",
          label: "计划名称"
        },
        {
          prop: "content",
          label: "任务内容"
        },
        {
          prop: "maName",
          label: "管理层级"
        },
        {
          prop: "now_period",
          label: "累计完成(次)"
        }
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable")
  },
  methods: {
    //选择每周日期 显示
    currWeekChange(val) {
    //   //console.log("选中的日期",val)
    //   this.$set(this.addEquipment, "open_time", val);
    //   //console.log(this.addEquipment.open_time,"addEquipment")
    },
    //选择每月日期 显示
    currMounthChange(val) {
    //   this.$set(this.addEquipment, "open_time", val);
    //   //console.log(this.addEquipment.open_time,"addEquipment")
    },
    //任务生成时间
    ifCreateTime(val) {
      this.addEquipment.open_time = "";
      //console.log(val);
      if (val === 0) {
        this.selectDays = false;
        this.selectMounth = false;
        this.showDays = false;
        this.showMounths = false;
      } else if (val === 1) {
        this.selectDays = true;
        this.selectMounth = false;
        this.showDays = true;
        this.showMounths = false;
      } else if (val === 2) {
        this.selectDays = false;
        this.selectMounth = true;
        this.showDays = true;
        this.showMounths = false;
      } else if (val === 3) {
        this.selectDays = false;
        this.selectMounth = true;
        this.showDays = true;
        this.showMounths = true;
      }
    },
    //搜索
    subSeefrom() {
      this.other = this.seefrom;
      this.$nextTick(this.$refs.plan.getData);
    },
    //重置
    reset() {
      this.seefrom = {};
    },
    // 启用/停用
    fConnect(value) {
      let list = value.row;
      let use_id = value.row.id;
      if (list.status === 0) {
        this.addEquipment.status = 1;
      } else {
        this.addEquipment.status = 0;
      }
      //console.log(list.status);
      var formData = new FormData();
      formData.append("id", use_id);
      formData.append("status", this.addEquipment.status);
      this.$axiospost("operation/programtab/updateStatus", formData).then(
        res => {
          if (list.status === 1) {
            this.$message.success("已停用");
            this.subSeefrom();
          } else {
            this.$message.success("已启用");
            this.subSeefrom();
          }
        }
      );
    },
    //新增
    toAddNew() {
      this.status = 1;
      this.title = "新增任务计划";
      this.displayForm = true;
      this.addEquipment = {
        name: "",
        content: "",
        ma_id: "",
        period: "",
        month: "",
        open_time: "",
        status: ""
      };
      if (this.$refs["addEquipment"])
        this.$refs["addEquipment"].clearValidate();
    },
    //编辑
    toEdit(index, row) {
      //console.log(row, "编辑");
      this.status = 2;
      this.title = "修改任务计划";
      this.displayForm = true;
      if (row.period === 0) {
        this.selectDays = false;
        this.selectMounth = false;
        this.showDays = false;
        this.showMounths = false;
      } else if (row.period === 1) {
        this.selectDays = true;
        this.selectMounth = false;
        this.showDays = true;
        this.showMounths = false;
      } else if (row.period === 2) {
        this.selectDays = false;
        this.selectMounth = true;
        this.showDays = true;
        this.showMounths = false;
      } else if (row.period === 3) {
        this.selectDays = false;
        this.selectMounth = true;
        this.showDays = true;
        this.showMounths = true;
      }
      this.addEquipment.name = row.name;
      this.addEquipment.content = row.content;
      this.addEquipment.ma_id = row.ma_id;
      this.addEquipment.period = row.period;
      this.addEquipment.open_time = row.open_time;
      this.addEquipment.month = row.month;
      this.edit_id = row.id;
      if (this.$refs["addEquipment"])
        this.$refs["addEquipment"].clearValidate();
    },
    //保存
    submitForm() {
      this.$refs.addEquipment.validate(valid => {
        if (valid) {
          if (this.status === 1) {
            this.$axiospost("operation/programtab/save", {
              name: this.addEquipment.name,
              content: this.addEquipment.content,
              ma_id: this.addEquipment.ma_id,
              period: this.addEquipment.period,
              open_time: this.addEquipment.open_time,
              month: this.addEquipment.month
            }).then(res => {
              this.$message.success("新增成功！");
              this.displayForm = false;
              this.$nextTick(this.$refs.plan.getData);
            });
          } else if (this.status === 2) {
            this.$axiospost("operation/programtab/save", {
              id: this.edit_id,
              name: this.addEquipment.name,
              content: this.addEquipment.content,
              ma_id: this.addEquipment.ma_id,
              period: this.addEquipment.period,
              open_time: this.addEquipment.open_time,
              month: this.addEquipment.month
            }).then(res => {
              this.$message.success("修改成功！");
              this.displayForm = false;
              this.$nextTick(this.$refs.plan.getData);
            });
          }
        }
      });
    },
    //删除
    deletePlan(index, row) {
      this.$confirm("是否删除该计划？", "删除操作", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axiosdelete("operation/programtab/delete", {
          params: {
            id: row.id
          }
        }).then(res => {
          this.$message.success("删除成功!");
          this.$nextTick(this.$refs.plan.getData);
        });
      }).catch(()=>{

      })
    }
  },
  created() {
    //管理层级
    this.$axiosget("operation/management/findAll", {
      params: {
        pageNum: 1,
        pageSize: 1000
      }
    }).then(res => {
      this.Hierarchy = res.data.data.list;
      //console.log(this.Hierarchy, "管理层级");
    });
  }
};
</script>

<style lang="less" scoped>
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-textarea__inner {
  border: 1px solid #3d4963;
  border-radius: 0;
  width: 310px;
  background: transparent;
  color: #cacaca;
  font-family: "Microsoft YaHei", "SF Pro Display", Roboto, Noto, Arial,
    "PingFang SC", sans-serif;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/mission/missionPlan.vue